export enum InfoMessagesOrdering {
  Title = 'Title',
  Message = 'Message',
  DisplayOrder = 'DisplayOrder',
  Status = 'Status',
  CreatedAt = 'CreatedAt',
}
